import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Grid, Paper, Theme, Typography, useTheme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { useTranslation } from 'mir-utils/i18n';
import { Header } from 'login-page/Logo';
import { IdecoStepper } from 'mir-utils/components';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grid: {
      padding: `${theme.spacing(5)} ${theme.spacing(10)}`,
    },
  })
);

export const InstructionInstall: FC = () => {
  const theme = useTheme();
  const { grid } = useStyles();
  const { t } = useTranslation();

  return (
    <Box display="flex" minHeight="100vh" justifyContent="center" alignItems="center">
      <Paper>
        <Header />
        <Grid direction="column" className={grid} container>
          <Grid item></Grid>
          <Grid item>
            <Box display="flex" justifyContent="center">
              <Typography variant="subtitle1">{t('Install and try Ideco NGFW')}</Typography>
            </Box>
          </Grid>
          <Grid item>
            <IdecoStepper
              activeStep={-1}
              alternativeLabel
              steps={[
                t('register'),
                t('Download ISO image'),
                t('Install on the server or hypervisor'),
              ]}
            />
          </Grid>
          <Grid item>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap={theme.spacing(4)}
              mb={4}
            >
              <Button variant="contained" size="medium" component={Link} to={'/login'}>
                {t('Log in')}
              </Button>
              <Button
                variant="contained"
                color="secondary"
                size="medium"
                component={Link}
                to={'/login/sign-up'}
              >
                {t('Sign up')}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};
